import { render, staticRenderFns } from "./PayoutForm.vue?vue&type=template&id=4a035b75&"
import script from "./PayoutForm.vue?vue&type=script&lang=ts&"
export * from "./PayoutForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports